export const APP_VERSION = '2.2.3';
